import {IApiResponse} from "modules/utils/Api/HTTPClient";

/**
 * Custom Errors handler
 */
export class ApiError extends Error {
	public static readonly AUTH_REQUIRED = 401;
	public static readonly USER_NOT_REGISTERED = 513;

	public static HAS_ERROR({errors}: IApiResponse) {
		return Boolean(Array.isArray(errors) && errors.length);
	}

	/**
	 * Should be called after each requests when we expect some errors or validations
	 */
	public static CHECK(response: IApiResponse) {
		if (ApiError.HAS_ERROR(response)) {
			const error = response.errors[0];
			throw new ApiError(error.message);
		}
	}

	public code?: number;

	constructor(m: string, code = 0) {
		super(m);
		this.name = "API Error";
		this.message = m;
		this.code = code;
	}
}
